import { TranslateService } from '../translate/translate.service';

export class RecordTabTitleUtility {
  public static pageLabel(translateService: TranslateService, translationKey: string, englishPageLabel: string): string {
    const translated: string = translateService.instant(translationKey);
    return translated === translationKey ? englishPageLabel : translated;
  }

  public static announcement(translateService: TranslateService, idAndLabel: string): string {
    const translated: string = translateService.instant('new_page_loaded', idAndLabel);
    if (translated.startsWith('new_page_loaded')) {
      return `New page ${idAndLabel} has been loaded.`;
    }
    return translated;
  }
}
